<template>
  <v-container>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-card
      width="100%"
      style="border-radius:10px;"
      class="pa-3"
      v-show="!overlay"
    >
      <!-- Header Title & Filter -->
      <v-card-title class="font-weight-light pb-0">
        <v-row
          align="center"
          class="w-100"
        >
          <v-col
            cols="12"
            :md="isIntimap || isWSP ? 3 : 5"
          >
            <span class="title font-weight-light">My Booking Details</span>
          </v-col>

          <v-col
            cols="12"
            md="4"
            v-if="isIntimap || isWSP"
          >
            <v-autocomplete
              v-model="filterredOrigins"
              :items="getPoolData"
              :item-text="(filter) => filter.name"
              :item-value="(filter) => filter.Id"
              label="Filter Origin"
              multiple
              outlined
              dense
              hide-details
            >
              <template #selection="{ item, index }">
                <span v-if="index === 0">{{ item.name }}</span>
                <span
                  v-if="index === 1"
                  class="grey--text caption"
                >
                  (+{{ filterredOrigins.length - 1 }} others)
                </span>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col
            cols="12"
            :md="isIntimap || isWSP ? 5 : 7"
          >
            <v-text-field
              v-model="searchData"
              append-icon="mdi-magnify"
              label="Search"
              :outlined="isIntimap || isWSP"
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </v-card-title>

      <!-- Filter Options Row -->
      <v-row
        class="px-4 pt-2"
        align="center"
      >
        <v-col
          cols="12"
          md="4"
        >
          <v-select
            v-model="selectedHeaders"
            :items="headersPools"
            label="Select Columns"
            multiple
            outlined
            dense
            return-object
            hide-details
            @change="handleChangeColumns"
          >
            <template #selection="{ item, index }">
              <v-chip
                v-if="index < 1"
                x-small
              >
                {{ item.text }}
              </v-chip>
              <span
                v-if="index === 1"
                class="grey--text caption"
              >
                (+{{ selectedHeaders.length - 1 }} Others)
              </span>
            </template>
          </v-select>
        </v-col>

        <v-col
          cols="12"
          md="5"
          class="text-md-center"
        >
          <h3
            class="font-weight-light text-subtitle mt-3 mt-md-0"
            v-if="isIntimap || isWSP"
          >
            All times displayed reflect the time zone of the vehicle's assigned depot
          </h3>
        </v-col>

        <v-col
          cols="12"
          md="3"
        >
          <div class="d-flex justify-end">
            <v-checkbox
              v-model="showHistory"
              label="Show Historical Data"
              dense
              hide-details
              @click="handleShowHistory"
            />
          </div>
        </v-col>
      </v-row>
      <v-data-table
        :headers="showHeaders"
        :items="getBookData"
        item-key="book_id"
        :class="getClassTable"
        :loading="loadingBook"
        :footer-props="footerProps"
        @update:options="updatePaging"
        :server-items-length="bookTotal"
      >
        <template #top>
          <v-dialog
            v-model="dialog"
            max-width="600"
          >
            <v-card 
              :height="
                showCostCode(selectedOrigin.book_detail) ||
                  showClientName(selectedOrigin.book_detail) ||
                  showWorkOrder(selectedOrigin.book_detail) ? 550 : 600"
            >
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title>Booking Details</v-toolbar-title>
                <v-spacer />
                <v-btn
                  icon
                  color="error"
                  @click="dialog = false"
                >
                  <v-icon color="white">
                    mdi-close-box
                  </v-icon>
                </v-btn>
                <template #extension>
                  <v-tabs
                    v-model="tabs"
                    centered
                  >
                    <v-tab>
                      Booking Information
                    </v-tab>
                    <v-tab>
                      Passenger Information
                    </v-tab>
                  </v-tabs>
                </template>
              </v-toolbar>

              <v-tabs-items v-model="tabs">
                <v-tab-item>
                  <v-card
                    min-width="350px"
                    flat
                    class="ma-4"
                  >
                    <v-row class=" justify-center text-center">
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                      >
                        <v-btn
                          outlined
                          color="primary"
                          class="primary--text text-center"
                          dense
                          @click="handleEditBooking(selectedOrigin.book_detail)"
                          v-show="pastCondition(selectedOrigin.book_detail) && !selectedOrigin.is_second_booking && selectedOrigin.book_detail.join_with == null"
                        >
                          Edit Booking
                        </v-btn>
                        <v-btn
                          outlined
                          color="primary"
                          class="primary--text text-center ml-2"
                          dense
                          @click="openEarlyReturnDialog(selectedOrigin)"
                          v-show="(isIntimap || isWSP) && pastCondition(selectedOrigin.book_detail) && !selectedOrigin.is_second_booking && selectedOrigin.book_detail.join_with == null && withinEarlyReturnWindow(selectedOrigin.book_detail) && !hasEarlyReturnTag(selectedOrigin.book_detail)"
                        >
                          Record early return
                        </v-btn>
                        <v-btn
                          outlined
                          color="primary"
                          class="primary--text text-center ml-2"
                          dense
                          @click="openEarlyPickupDialog(selectedOrigin)"
                          v-show="(isIntimap || isWSP) && pastCondition(selectedOrigin.book_detail) && !selectedOrigin.is_second_booking && selectedOrigin.book_detail.join_with == null && withinEarlyPickupWindow(selectedOrigin.book_detail) && !hasEarlyPickupTag(selectedOrigin.book_detail)"
                        >
                          Record early pickup
                        </v-btn>
                        <v-btn
                          outlined
                          color="error"
                          class="text-center ml-2"
                          dense
                          @click="cancelBooking(selectedOrigin)"
                          v-show="pastCondition(selectedOrigin.book_detail, true) && !selectedOrigin.is_second_booking && canDeleteThisBooking(selectedOrigin)"
                        >
                          Delete booking
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-subheader>Schedule Information</v-subheader>
                    <div class="px-5 my-0 pb-2">
                      <div class="my-5">
                        <v-icon
                          color="primary"
                          left
                        >
                          mdi-account
                        </v-icon>
                        <span>{{ selectedOrigin.username }}</span>
                      </div>
                      <div class="my-5">
                        <v-icon
                          color="primary"
                          left
                        >
                          mdi-map-marker
                        </v-icon>
                        From
                        <b>
                          {{ getConfirmOriginName(selectedOrigin.book_detail) }}
                        </b>
                        To
                        <b>
                          <span>{{
                            getDestinationAddrs(selectedOrigin.book_detail)
                          }}</span>
                        </b>
                      </div>
                      <div class="my-5">
                        <v-icon
                          color="primary"
                          left
                        >
                          mdi-car
                        </v-icon>
                        <span>
                          {{
                            getConfirmVehicleName(selectedOrigin.book_detail)
                          }}</span>
                      </div>
                      <div class="my-5">
                        <v-icon
                          color="primary"
                          left
                        >
                          mdi-calendar-clock
                        </v-icon>
                        {{ getDates(selectedOrigin.book_detail) }}
                      </div>
                      <div class="my-5">
                        <v-icon
                          color="primary"
                          left
                        >
                          mdi-clock-time-three-outline
                        </v-icon>
                        {{ getDuration(selectedOrigin.book_detail) }}
                      </div>
                      <div
                        class="my-5"
                        v-if="showCostCode(selectedOrigin.book_detail)"
                      >
                        <v-icon
                          color="primary"
                          left
                        >
                          mdi-currency-usd
                        </v-icon>
                        {{ getCostCode(selectedOrigin.book_detail) }}
                      </div>
                      <div
                        class="my-5 d-flex"
                        v-if="showWorkOrder(selectedOrigin.book_detail)"
                      >
                        <v-icon
                          color="primary"
                          left
                        >
                          mdi-order-alphabetical-ascending
                        </v-icon>
                        <div v-if="!isEditingWorkOrder">
                          Work Order: {{ getWorkOrder(selectedOrigin.book_detail) }}
                          <v-btn
                            v-if="!canEditBooking(selectedOrigin) && !selectedOrigin.readonly"
                            icon
                            small
                            color="primary"
                            @click="startEditWorkOrder"
                            class="ml-2"
                          >
                            <v-icon small>
                              mdi-pencil
                            </v-icon>
                          </v-btn>
                        </div>
                        <div
                          v-else
                          class="d-flex align-center"
                        >
                          <v-autocomplete
                            v-model="editingWorkOrder"
                            :items="workOrders"
                            :search-input.sync="searchWorkOrder"
                            :loading="isLoadingWorkOrder"
                            hide-selected
                            hide-no-data
                            clearable
                            :item-text="getWorkOrderText"
                            item-value="code"
                            label="Work Order"
                            outlined
                            dense
                            required
                            :rules="workOrderRule"
                            placeholder="Search Work Orders"
                            style="max-width: 300px;"
                            return-object
                          />
                          <v-btn
                            icon
                            small
                            color="green"
                            @click="saveWorkOrder"
                            class="ml-2"
                            :loading="loadingUpdate"
                          >
                            <v-icon small>
                              mdi-check
                            </v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            small
                            color="red"
                            @click="cancelEditWorkOrder"
                            class="ml-1"
                          >
                            <v-icon
                              small
                            >
                              mdi-close
                            </v-icon>
                          </v-btn>
                        </div>
                      </div>
                      <div
                        class="my-5"
                        v-if="showPurposeOfTrip(selectedOrigin.book_detail)"
                      >
                        <v-icon
                          color="primary"
                          left
                        >
                          mdi-tag-text-outline
                        </v-icon>
                        Purpose of Trip: {{ getPurposeOfTrip(selectedOrigin.book_detail) }}
                      </div>
                      <div
                        class="my-5"
                        v-if="showClientName(selectedOrigin.book_detail)"
                      >
                        <v-icon
                          color="primary"
                          left
                        >
                          mdi-account-star
                        </v-icon>
                        {{ getClientName(selectedOrigin.book_detail) }}
                      </div>
                      <div class="my-5">
                        <v-icon
                          color="primary"
                          left
                        >
                          mdi-map
                        </v-icon>
                        Car Park Location: {{ getCarParkLocation(selectedOrigin.book_detail) }}
                      </div>
                      <div class="my-5 ">
                        <v-icon
                          color="primary"
                          left
                        >
                          mdi-key
                        </v-icon>
                        Key Cabinet Location: {{ getKeCabinetLocation(selectedOrigin.book_detail) }}
                      </div>
                    </div>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card
                    flat
                    class="pa-4"
                  >
                    <v-simple-table class="ma-5 blue lighten-5">
                      <template #default>
                        <thead>
                          <tr>
                            <th>No</th>
                            <th>Booked By</th>
                            <th>No of Occupants</th>
                            <th v-show="isHaveRideShare(selectedOrigin)">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(passenger, i) in selectedOrigin.book_detail.passenger"
                            :key="i"
                          >
                            <td>{{ i + 1 }}</td>
                            <td>
                              {{
                                `${passenger.first_name} ${passenger.last_name}`
                              }}
                              <v-chip
                                x-small
                                class="ma-2"
                                color="primary"
                                dark
                                v-if="passenger.is_owner"
                              >
                                Owner
                              </v-chip>
                            </td>
                            <td v-if="isIntimap || isWSP">
                              <v-tooltip
                                bottom
                                :open-delay="500"
                              >
                                <template #activator="{ on, attrs }">
                                  <v-chip
                                    class="ma-1"
                                    color="primary"
                                    dark
                                    style="font-size: 0.75rem;"
                                    v-on="on"
                                    v-bind="attrs"
                                  >
                                    {{ passenger.passenger_count }} Passenger
                                  </v-chip>
                                </template>
                                <table>
                                  <tbody>
                                    <tr>
                                      <td>
                                        <p
                                          v-for="pName in getPassengerList(passenger)"
                                          :key="pName"
                                        >
                                          {{ pName }}
                                        </p>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </v-tooltip>
                            </td>
                            <td v-else>
                              {{ passenger.passenger_count }}
                            </td>
                            <td v-show="isCanCancelJoin(passenger)">
                              <v-icon
                                small
                                class="ml-1"
                                @click="cancelJoin(passenger)"
                                color="red"
                                v-if="!passenger.is_owner"
                              >
                                mdi-delete
                              </v-icon>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-dialog>
        </template>
        <template #loading>
          <span v-if="loadingBook && getBookData.length == 0">
            Loading
          </span>
          <span v-if="!loadingBook && getBookData.length == 0">
            There's no booking you've made, please <a :href="`${getCarpoolURL()}/#/book`">click here</a> to create booking.
          </span>
        </template>
        <template #no-data>
          There's no booking you've made, please <a :href="`${getCarpoolURL()}/#/book`">click here</a> to create booking.
        </template>
        <template #[`item.book_detail.start_geofence_id`]="{ item }">
          {{ getOriginName(item.book_detail) }}
        </template>
        <template #[`item.book_detail.vehicle_name`]="{ item }">
          {{ getVehicleName(item.book_detail) }}
        </template>
        <template #[`item.book_detail.vehicle_make`]="{ item }">
          {{ getVehicleMake(item.book_detail) }}
        </template>
        <template #[`item.book_detail.vehicle_model`]="{ item }">
          {{ getVehicleModel(item.book_detail) }}
        </template>
        <template #[`item.book_detail.end_geofence_id`]="{ item }">
          {{ getDestinationAddr(item.book_detail) }}
        </template>
        <template #[`item.book_detail.recurring`]="{ item }">
          <div v-if="item.book_detail.recurring == '1'">
            <v-tooltip
              bottom
              :open-delay="500"
            >
              <template #activator="{ on, attrs }">
                <v-icon
                  v-if="item.book_detail.recurring == '1'"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-check
                </v-icon>
              </template>
              <table v-if="item.book_detail.booking_recurring">
                <tbody>
                  <tr
                    v-for="r in item.book_detail.booking_recurring"
                    :key="r.id"
                  >
                    <td>{{ formatDate(r.start_datetime, 'ddd, D MMM YYYY HH:mm') }}</td>
                    <td> &nbsp; - &nbsp; </td>
                    <td>{{ formatDate(r.end_datetime, 'ddd, D MMM YYYY HH:mm') }}</td>
                  </tr>
                </tbody>
              </table>
            </v-tooltip>
          </div>
        </template>
        <template
          #[`item.action`]="{ item }"
          style="width : 100px;"
        >
          <div
            class="d-flex"
            :style="`display: ${item.hasOwnProperty('readonly') ? 'none !important' : ''};`"
          >
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-1"
                  v-bind="attrs"
                  v-on="{ ...on, click: () => editItem(item) }"
                  color="primary"
                >
                  mdi-eye
                </v-icon>
              </template>
              <span>View details</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-1"
                  v-bind="attrs"
                  v-on="{ ...on, click: () => handleEditBooking(item.book_detail) }"
                  v-show="pastCondition(item.book_detail) && !item.is_second_booking && item.book_detail.join_with == null"
                  color="primary"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Edit booking</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-1"
                  v-bind="attrs"
                  v-on="{ ...on, click: () => openEarlyReturnDialog(item) }"
                  v-show="(isIntimap || isWSP) && pastCondition(item.book_detail) && !item.is_second_booking && item.book_detail.join_with == null && withinEarlyReturnWindow(item.book_detail) && !hasEarlyReturnTag(item.book_detail)"
                  color="primary"
                >
                  mdi-keyboard-return
                </v-icon>
              </template>
              <span>Record early return</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-1"
                  v-bind="attrs"
                  v-on="{ ...on, click: () => openEarlyPickupDialog(item) }"
                  v-show="(isIntimap || isWSP) && pastCondition(item.book_detail) && !item.is_second_booking && item.book_detail.join_with == null && withinEarlyPickupWindow(item.book_detail) && !hasEarlyPickupTag(item.book_detail)"
                  color="primary"
                >
                  mdi-clock-fast
                </v-icon>
              </template>
              <span>Record early pickup</span>
            </v-tooltip>
            <v-icon
              small
              class="ml-1"
              @click="cancelBooking(item)"
              color="red"
              v-if="pastCondition(item.book_detail, true) && !item.is_second_booking && canDeleteThisBooking(item)"
            >
              mdi-delete
            </v-icon>
          </div>
        </template>
        <template #[`item.book_detail.start_datetime`]="{ item }">
          {{ startDateFormat(item.book_detail) }}
        </template>
        <template #[`item.book_detail.end_datetime`]="{ item }">
          {{ endDateFormat(item.book_detail) }}
        </template>
        <template #[`item.book_detail.metadata.start_left_depot.adatetime`]="{ item }">
          {{ toTimezoneUser(item.book_detail, 'start_left_depot') }}
        </template>
        <template #[`item.book_detail.metadata.end_back_depot.adatetime`]="{ item }">
          {{ toTimezoneUser(item.book_detail, 'end_back_depot') }}
        </template>
        <template #[`item.book_detail.created_at`]="{ item }">
          {{ formatDate(item.book_detail.created_at) }}
        </template>
        <v-data-footer />
      </v-data-table>
    </v-card>
    <v-dialog
      v-model="dialogRecurring"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Schedule for Booking with ID {{ selectedBookId }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-data-table
                  :headers="headersSchedule"
                  :items="schedules"
                  :items-per-page="10"
                  class="elevation-1"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="dialogRecurring = false; clearSchedules()"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="dialogRecurring = false; clearSchedules()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deldialog"
      persistent
      max-width="560"
    >
      <v-card
        dark
        color="red"
      >
        <v-card-title>
          <span>
            <v-icon>mdi-alert-circle</v-icon> Are you sure want to
            {{ getDeleteMessage() }}
          </span>
        </v-card-title>
        <v-card-text>
          You will delete this booking permanently.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="deldialog = false"
          >
            No
          </v-btn>
          <v-btn
            text
            @click="submitDeleteBooking()"
            :loading="loadingUpdate"
            :disabled="loadingUpdate"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Record early return: alter end time to actual return time -->
    <v-dialog
      v-model="dialogEarlyReturn"
      persistent
      max-width="520"
      content-class="my-booking-dialog"
    >
      <v-card>
        <v-card-title class="text-subtitle-1">
          Record early return
        </v-card-title>
        <v-card-text>
          <p class="mb-3 grey--text text--darken-1">
            Vehicle was returned earlier than the booked end time. Set the actual return time.
          </p>
          <v-autocomplete
            v-model="earlyReturnTime"
            :items="earlyReturnTimeOptions"
            item-text="label"
            item-value="value"
            label="Actual return time"
            outlined
            dense
            hide-details
            clearable
            placeholder="Type to search (e.g. 4 Mar or 07:30)"
          />
          <p
            v-if="earlyReturnError"
            class="caption red--text mt-2"
          >
            {{ earlyReturnError }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialogEarlyReturn = false; earlyReturnError = ''"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="alterBookingLoading"
            @click="submitEarlyReturn"
          >
            Update booking
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Record early pickup: alter start time to actual pickup time -->
    <v-dialog
      v-model="dialogEarlyPickup"
      persistent
      max-width="520"
      min-height="300"
      content-class="my-booking-dialog"
    >
      <v-card>
        <v-card-title class="text-subtitle-1">
          Record early pickup
        </v-card-title>
        <v-card-text>
          <p class="mb-3 grey--text text--darken-1">
            Vehicle was taken earlier than the booked start time. Set the actual pickup time.
          </p>
          <v-select
            v-model="earlyPickupTime"
            :items="earlyPickupTimeOptions"
            item-text="label"
            item-value="value"
            label="Actual pickup time"
            outlined
            dense
            hide-details
          />
          <p class="caption grey--text mt-1 mb-0">
            Maximum 2 hours before the booked start time.
          </p>
          <p
            v-if="earlyPickupError"
            class="caption red--text mt-2"
          >
            {{ earlyPickupError }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialogEarlyPickup = false; earlyPickupError = ''"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="alterBookingLoading"
            @click="submitEarlyPickup"
          >
            Update booking
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
/* eslint-disable */

const qs = require("qs");
import moment from "moment";
import momentTz from "moment-timezone";
import isNull from "lodash/isNull";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import isUndefined from "lodash/isUndefined";
import cloneDeep from "lodash/cloneDeep";
import debounce from "lodash/debounce";
import { getBookingDestinationText } from "@/plugins/destination";

export default {
  data() {
    return {
      menu2: false,
      time: null,
      menu3: false,
      tabs: null,
      isPast: false,
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      editedItem: {
        clientid: "",
        id: "",
        book_detail: {
          start_geofence_id: "",
          start_datetime: "",
          end_datetime: "",
        },
        passenger_count: "",
      },
      passenger_manifest: {
        email: "",
        name: "",
        phone: "",
        start_datetime: "",
        end_datetime: "",
        from: "",
        to: "",
      },
      dialog: false,
      dialogEarlyReturn: false,
      dialogEarlyPickup: false,
      alterBookingItem: null,
      earlyReturnDateTime: null,
      earlyPickupDateTime: null,
      earlyReturnDate: '',
      earlyReturnTime: '',
      earlyPickupDate: '',
      earlyPickupTime: '',
      earlyReturnError: '',
      earlyPickupError: '',
      alterBookingLoading: false,
      chartOptions: {
        chart: {
          title: "Statistic for Most Used User",
          subtitle: "Admin, Dean, Dwiky, Superadmin",
        },
      },
      chartData: [],
      headersPools: [
        { text: "Booking ID", value: "book_detail.id" },
        { text: 'First Name', align: 'left', value: 'first_name' },
        { text: 'Last Name', align: 'left', value: 'last_name' },
        { text: "From", value: "book_detail.start_geofence_id" },
        { text: "To", value: "book_detail.end_geofence_id" },
        { text: "Start Date", value: "book_detail.start_datetime" },
        { text: "End Date", value: "book_detail.end_datetime" },
        { text: "Asset Name", value: "book_detail.vehicle_name" },
        {text: "Recurring", value: "book_detail.recurring", sortable: false},
        {text: "Created At", value: "book_detail.created_at"},
        { text: "Actions", value: "action", sortable: false },
      ],
      userChart: [],
      booked: 0,
      getBookData: [],
      getBookedData: [],
      getVehicles: [],
      no_passenger: "",
      responsive: true,
      getDevice: 0,
      deviceLoaded: false,
      chartNull: false,
      countDevice: 0,
      dataPool: [],
      dataPools: [],
      notBooked: 0,
      updatedVehicle: "",
      start: null,
      match: [],
      not_match: [],
      end: null,
      now: null,
      e1: 1,
      filterredOrigins: [],
      selectedOrigin: "",
      detailValidate: true,
      oriGeoId: "",
      parent_id: "",
      sharedBook: false,
      startDateTime: "",
      endDateTime: "",
      noPassenger: "",
      selectedVehicle: "",
      selectedAddr: "",
      setAddr: "",
      sharedVehicle: false,
      setDestination: "",
      selectedStartDate: "",
      selectedStartTime: "",
      showSuccess: false,
      setVehicleName: "",
      loader: null,
      snackbar: false,
      options: [],
      text: "LOADING ...",
      entries: [],
      items: [],
      isLoading: false,
      model: null,
      search: null,
      type_of_vehicle: [
        "Passenger Car 5 Seats",
        "Passenger Car 7-8 Seats",
        "Ute",
        "Other",
      ],
      center: { lat: -23.8511901, lng: 131.2038283 },
      zoom: 4,
      gmapOption: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
      },
      numberRule: (v) => {
        if (!v.trim()) return true;
        if (!isNaN(parseFloat(v)) && v >= 0 && v <= 99) return true;
        return "Number of passenger must to be more than 1";
      },
      oriPosition: { lat: 0, lng: 0 },
      chartsLib: null,
      availTl: "",
      gChartOptions: {
        timeline: {
          showRowLabels: false,
        },
        hAxis: {
          format: "HH:mm",
        },
        colors: ["#66bb6a", "#e57373"],
        width: 1055,
        height: 100,
        avoidOverlappingGridLines: false,
      },
      destPosition: null,
      vehicleId: null,
      setConfirmBook: [],
      token: this.$store.state.token,
      userId: this.$store.state.user.user.id,
      valid: true,
      selectRules: [(v) => !!v || "Item is required"],
      dateRules: [(v) => !!v || "Item is required"],
      destAddr: "",
      selectedId: "",
      endDateDialog: false,
      display: false,
      loadingBook: false,
      searchData: "",
      searchTimeout: null,
      bookTotal: 0,
      footerProps: {
        itemsPerPageOptions: [2, 3, 5, 10, 20, 50, 100, 200, 500]
      },
      paginationOptions: {
        sortBy: [],
        sortDesc: [],
        page: 1,
        itemsPerPage: 10
      },
      overlay: false,
      selectedBookId: null,
      dialogRecurring: false,
      recurringData: [],
      headersSchedule: [
        {
          text: 'Username',
          value: 'username',
          sortable: false,
        },
        {
          text: 'From',
          value: "start_geofence_id",
          sortable: false,
        },
        {
          text: 'To',
          value: "end_geofence_id",
          sortable: false,
        },
        {
          text: 'Start Date',
          value: "start_datetime",
          sortable: false,
        },
        {
          text: 'End Date',
          value: "end_datetime",
          sortable: false,
        },
        {
          text: 'Asset Name',
          value: "asset_name",
          sortable: false,
        },
      ],
      deldialog: false,
      deleteTarget: null,
      loadingUpdate: false,
      loader: null,
      assetTypes: [],
      showHistory: false,
      selectedHeaders: [],
      workOrders: [],
      isEditingWorkOrder: false,
      editingWorkOrder: {},
      searchWorkOrder: '',
      isLoadingWorkOrder: false,
      workOrderRule: [
        v => !this.isEmpty(v) || "Work Order is required"
      ],
    };
  },
  created() {
    //data booked
    this.$store.dispatch("LOAD_TIMEZONES");
    this.$store.dispatch("GET_ALL_GEOFENCES");
    this.$store.dispatch("GET_GEOFENCES");

    //data for origin
    this.$store.dispatch("LOAD_POOL_DATA");
    this.getAllDevice();
    this.getDataVehicles();
    if (this.isWSP || this.isIntimap) this.getDataWorkOrder();
    setTimeout(() => {
      this.$store.dispatch("LOAD_POOL_DATA");
    }, 1e3);
    this.overlay = true;
    if (localStorage.getItem("selectedHeaders")) {
      this.selectedHeaders = JSON.parse(localStorage.getItem("selectedHeaders"));
    } else {
      this.selectedHeaders = Object.assign([], this.headersPools);
    }
    if (this.isVictrack || this.isWSP || this.isIntimap) {
      this.headersPools = [
        { text: "Booking ID", value: "book_detail.id" },
        { text: 'First Name', align: 'left', value: 'first_name' },
        { text: 'Last Name', align: 'left', value: 'last_name' },
        { text: "From", value: "book_detail.start_geofence_id" },
        { text: "To", value: "book_detail.end_geofence_id" },
        { text: "Start Date", value: "book_detail.start_datetime" },
        { text: "End Date", value: "book_detail.end_datetime" },
        { text: "Asset Name", value: "book_detail.vehicle_name" },
        {text: "Recurring", value: "book_detail.recurring", sortable: false},
        {text: "Created At", value: "book_detail.created_at"},
        { text: "Time - Left Depot", value: "book_detail.metadata.start_left_depot.adatetime" },
        { text: "Time - Back Depot", value: "book_detail.metadata.end_back_depot.adatetime" },
        { text: "Actions", value: "action", sortable: false },
      ];
    }
  },
  watch: {
    endDateTime(value) {
      if (this.startDateTime > value) {
        this.endDateDialog = true;
      }
    },
    searchData(value) {
      this.doSearch();
    },
    overlay(val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 2e3)
    },
    deldialog(show) {
      if (!show) {
        this.deleteTarget = null;
      }
    },
    loader() {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    },
    filterredOrigins() {
      this.doSearch();
    },
    searchWorkOrder: {
      handler: debounce(function (val) {
        if (this.editingWorkOrder) {
          if (this.editingWorkOrder.code == val) {
            return;
          }
        }
        this.fetchWorkOrders(val);
      }, 500),
      immediate: false,
    },
  },
  computed: {
    getClassTable() {
      return this.$vuetify.breakpoint.mobile ? 'font-weight-light' : 'font-weight-light my-data-table';
    },
    earlyReturnHourRange() {
      if (!this.alterBookingItem || !this.alterBookingItem.book_detail) return undefined;
      const b = this.alterBookingItem.book_detail;
      const minAllowed = this.getEarlyReturnMinMoment(b);
      const startH = minAllowed ? minAllowed.hour() : moment(b.start_datetime).hour();
      const endH = moment(b.end_datetime).hour();
      return this.getHourRanges(startH, endH);
    },
    earlyReturnTimeOptions() {
      if (!this.alterBookingItem || !this.alterBookingItem.book_detail) return [];
      return this.getEarlyReturnTimeOptions(this.alterBookingItem.book_detail);
    },
    earlyPickupTimeOptions() {
      if (!this.alterBookingItem || !this.alterBookingItem.book_detail) return [];
      return this.getEarlyPickupTimeOptions(this.alterBookingItem.book_detail);
    },
    getPoolData() {
      return this.$store.getters.getPoolData.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
    },
    showHeaders () {
      return this.headersPools.filter(h => this.selectedHeaders.find(s => s.value === h.value));
    },
    fields() {
      if (!this.model) return [];
      return Object.keys(this.model).map((key) => {
        return {
          key,
          value: this.model[key] || "n/a",
        };
      });
    },
    destination() {
      return this.entries.map((entry) => {
        const key = btoa(`${entry.address}-${entry.lat}-${entry.lng}`);
        return Object.assign({}, entry, { key });
      });
    },
    getAvailVehicle() {
      return this.$store.getters.getVehiclesData;
    },
    getDestinationData() {
      return this.$store.getters.getDestinationData;
    },
    all_geofences() {
      return this.$store.getters["getAllGeofencesData"];
    },
    geofences() {
      return this.$store.getters["getGeofencesData"];
    },
    schedules() {
      return this.$store.getters['schedules'];
    },
    loadSchedule() {
      return this.$store.getters['loadSchedule'];
    },
    timezones() {
      return this.$store.getters["getTimezones"];
    },
    isWSP() {
      return this.$store.state.clientid == 'H1O5G7P0N3JA';
    },
    isVictrack() {
      return this.$store.state.clientid == 'B34UUE8JJML5';
    },
    isIntimap() {
      return this.$store.state.clientid == 'DSSTWWLLIHH7';
    },
    isWollongong() {
      return this.$store.state.clientid == 'A506MF91OINZ';
    },
  },
  mounted() {
    this.getBookTotal();
    this.getData();
    this.getAssetType();
    // this.getDataVehicles();
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    getHourRanges(startHour, endHour) {
      if (startHour <= endHour) {
        return [[startHour, endHour]];
      }

      return [
        [startHour, 23],
        [0, endHour],
      ];
    },
    isHaveRideShare(item) {
      if (item && !item.book_detail) item = this.getBookData.find(b => b.book_detail.id == item.book_id);
      if (item && item.book_detail) {
        return item.book_detail.passenger.some((p) => {
          return p.is_owner == 0 && p.user_id == this.$store.state.user.user.id ||
            p.is_owner == true && this.$store.state.user.user.id == p.user_id;
        });
      }
      return false;
    },
    canDeleteThisBooking(item) {
      if (item && item.book_detail && item.book_detail.join_with != null) {
        const otherPassengers = item.book_detail.passenger.filter(p => p.is_owner == 0);
        if (otherPassengers.length > 0) {
          const isCurrentUserInOtherPassengers = otherPassengers.some(p => p.user_id == this.$store.state.user.user.id);
          if (isCurrentUserInOtherPassengers) {
            return true;
          } else {
            return false;
          }
        }
      }
      return true;
    },
    getDeleteMessage() {
      const isHaveRideShare = this.isHaveRideShare(this.deleteTarget);
      if (isHaveRideShare) {
        if (this.deleteTarget.book_detail.join_with != null) {
          return 'cancel this ride share booking?';
        }
      }
      return 'delete this booking?';
    },
    // Helper method to split booking with original_end_time
    splitBookingWithOriginalEndTime(item) {
      let metadata = {};
      try {
        if (typeof item.book_detail.metadata === 'string') {
          metadata = JSON.parse(item.book_detail.metadata);
        } else {
          metadata = item.book_detail.metadata;
        }
      } catch (e) {}

      // Check if this booking has original_end_time (indicating it should be split)
      if (metadata.hasOwnProperty('original_end_time') && 
          metadata.hasOwnProperty('start_second_work_order') && 
          metadata.hasOwnProperty('end_second_work_order') && 
          metadata.hasOwnProperty('second_work_order')) {
        
        const bookings = [];
        
        // First booking (original) - modify end_datetime to original_end_time
        const firstBooking = cloneDeep(item);
        firstBooking.book_detail.end_datetime = metadata.original_end_time;
        firstBooking.book_detail.id = firstBooking.book_detail.id + '-1';
        
        // Remove second booking related metadata from first booking
        const firstMetadata = { ...metadata };
        delete firstMetadata.original_end_time;
        delete firstMetadata.start_second_work_order;
        delete firstMetadata.end_second_work_order;
        delete firstMetadata.second_work_order;
        firstBooking.book_detail.metadata = JSON.stringify(firstMetadata);
        
        bookings.push(firstBooking);
        
        // Second booking - use start_second_work_order and end_second_work_order
        const secondBooking = cloneDeep(item);
        secondBooking.book_detail.start_datetime = metadata.start_second_work_order;
        secondBooking.book_detail.end_datetime = metadata.end_second_work_order;
        secondBooking.book_detail.id = secondBooking.book_detail.id + '-2';
        
        // Update metadata for second booking
        const secondMetadata = { ...metadata };
        secondMetadata.work_order = metadata.second_work_order;
        delete secondMetadata.original_end_time;
        delete secondMetadata.start_second_work_order;
        delete secondMetadata.end_second_work_order;
        delete secondMetadata.second_work_order;
        secondBooking.book_detail.metadata = JSON.stringify(secondMetadata);
        secondBooking.is_second_booking = true;
        
        bookings.push(secondBooking);
        
        return bookings;
      }
      
      // Return original item if no split needed
      return [item];
    },

    // Helper method to process booking data with split logic and histories
    processBookingData(bookingData) {
      return bookingData.reduce((acc, item) => {
        // Split booking if it has original_end_time
        const splitBookings = this.splitBookingWithOriginalEndTime(item);
        
        splitBookings.forEach(splitItem => {
          let metadata = {};
          try {
            if (typeof splitItem.book_detail.metadata === 'string') {
              metadata = JSON.parse(splitItem.book_detail.metadata);
            } else {
              metadata = splitItem.book_detail.metadata;
            }
          } catch (e) {}
          let idx = 0
          let initialId = null
          if (metadata.hasOwnProperty('histories')) {
            for (const history of metadata.histories) {
              if (isNull(initialId)) {
                initialId = history.id;
              } else {
                idx += 1;
              }
              const newHistory = cloneDeep(splitItem);
              newHistory.readonly = 1;
              newHistory.book_detail.original_id = history.id;
              newHistory.book_detail.id = initialId + (idx > 0 ? ' - ' + idx : '');
              newHistory.book_detail.start_datetime = history.start_datetime;
              newHistory.book_detail.end_datetime = history.end_datetime;
              newHistory.book_detail.created_at = history.created_at;
              acc.push(newHistory);
            }
            if (idx > 0) {
              idx += 1;
            } else if (metadata.histories.length) {
              idx += 1;
            }
          }
          splitItem.book_detail.original_id = splitItem.book_detail.id;
          splitItem.book_detail.id = idx > 0 ? initialId + ' - ' + idx : splitItem.book_detail.id
          acc.push(splitItem);
        });
        
        return acc;
      }, []);
    },
    
    getDataWorkOrder() {
      this.fetchWorkOrders().then(() => {
        this.ensureCurrentWorkOrderInList();
        // Pastikan current work order ada di list untuk semua booking yang ditampilkan
        this.ensureAllCurrentWorkOrdersInList();
      });
    },
    getCurrentWorkOrdersFromBookings() {
      const currentWorkOrders = [];
      
      if (this.selectedOrigin && this.selectedOrigin.book_detail) {
        const currentWorkOrder = this.getWorkOrder(this.selectedOrigin.book_detail);
        if (currentWorkOrder) {
          currentWorkOrders.push({ 
            code: currentWorkOrder, 
            description: currentWorkOrder 
          });
        }
      }
      
      return currentWorkOrders;
    },
    ensureCurrentWorkOrderInList() {
      if (this.selectedOrigin && this.selectedOrigin.book_detail) {
        const currentWorkOrder = this.getWorkOrder(this.selectedOrigin.book_detail);
        if (currentWorkOrder) {
          const workOrderExists = this.workOrders.find((wo) => wo.code == currentWorkOrder);
          if (!workOrderExists) {
            const currentWO = { code: currentWorkOrder, description: currentWorkOrder };
            this.workOrders.unshift(currentWO);
          }
        }
      }
    },
    ensureAllCurrentWorkOrdersInList() {
      // Pastikan semua work order yang digunakan di booking ada di list
      const seenCodes = new Set();
      this.getBookedData.forEach(booking => {
        const currentWorkOrder = this.getWorkOrder(booking.book_detail);
        if (currentWorkOrder && !seenCodes.has(currentWorkOrder)) {
          seenCodes.add(currentWorkOrder);
          const workOrderExists = this.workOrders.find((wo) => wo.code == currentWorkOrder);
          if (!workOrderExists) {
            const currentWO = { code: currentWorkOrder, description: currentWorkOrder };
            this.workOrders.unshift(currentWO);
          }
        }
      });
    },
    fetchWorkOrders(search) {
      this.isLoadingWorkOrder = true;
      return this.$store
        .dispatch("API_CALL", {
          $method: "get_work_order",
          $postData: {
            clientid: this.$store.state.clientid,
            query: search || '',
            limit: 100,
            offset: 0,
          }
        })
        .then(response => {
          const newList = (response && response.data && response.data.data) || [];
          
          const currentWorkOrders = this.getCurrentWorkOrdersFromBookings();
          const combinedList = [...newList];
          
          currentWorkOrders.forEach(currentWO => {
            const exists = combinedList.find(wo => wo.code === currentWO.code);
            if (!exists) {
              combinedList.unshift(currentWO); // Add to beginning
            }
          });
          
          this.workOrders = combinedList;
        })
        .finally(() => {
          this.isLoadingWorkOrder = false;
        });
    },
    handleChangeColumns() {
      this.$nextTick(() => {
        localStorage.setItem('selectedHeaders', JSON.stringify(this.selectedHeaders));
      });
    },
    handleEditBooking(item) {
      this.dialog = false;
      const editId = item.original_id || item.id;
      this.$router.push({ path: `/book/${editId}` });
    },
    openEarlyReturnDialog(item) {
      this.alterBookingItem = item;
      const b = item.book_detail;
      if (!b) return;
      const geofenceId = b.start_geofence_id;
      const bookingEndMoment = this.parseDepotTime(b.end_datetime, geofenceId);
      const options = this.getEarlyReturnTimeOptions(b);
      const selectedOption = options.length ? options[options.length - 1].value : '';
      const m = selectedOption ? this.parseDepotTime(selectedOption, geofenceId) : bookingEndMoment.clone().subtract(30, 'minutes');
      this.earlyReturnDate = m.format('YYYY-MM-DD');
      this.earlyReturnTime = selectedOption;
      this.earlyReturnError = options.length ? '' : 'No valid early return time can be selected right now.';
      this.dialog = false;
      this.dialogEarlyReturn = true;
    },
    openEarlyPickupDialog(item) {
      this.alterBookingItem = item;
      const b = item.book_detail;
      if (!b) return;
      const geofenceId = b.start_geofence_id;
      const bookingStartMoment = this.parseDepotTime(b.start_datetime, geofenceId);
      const options = this.getEarlyPickupTimeOptions(b);
      const selectedOption = options.length ? options[options.length - 1].value : '';
      const m = selectedOption ? this.parseDepotTime(selectedOption, geofenceId) : bookingStartMoment.clone().subtract(30, 'minutes');
      this.earlyPickupDate = m.format('YYYY-MM-DD');
      this.earlyPickupTime = selectedOption;
      this.earlyPickupError = options.length ? '' : 'No valid early pickup time can be selected right now.';
      this.dialog = false;
      this.dialogEarlyPickup = true;
    },
    submitEarlyReturn() {
      if (!this.alterBookingItem || !this.alterBookingItem.book_detail) return;
      if (!this.earlyReturnTime) {
        this.earlyReturnError = 'Please select a time.';
        return;
      }
      const b = this.alterBookingItem.book_detail;
      const bookId = b.original_id || b.id;
      const geofenceId = b.start_geofence_id;
      const start = moment(b.start_datetime).format('YYYY-MM-DD HH:mm');
      const selectedInput = this.earlyReturnTime && this.earlyReturnTime.includes(' ')
        ? this.earlyReturnTime
        : `${this.earlyReturnDate} ${this.earlyReturnTime}`;
      const selectedMoment = this.parseDepotTime(selectedInput, geofenceId);
      const bookingStartMoment = this.parseDepotTime(b.start_datetime, geofenceId);
      const bookingEndMoment = this.parseDepotTime(b.end_datetime, geofenceId);
      const newEnd = selectedMoment.format('YYYY-MM-DD HH:mm');
      if (selectedMoment.isAfter(bookingEndMoment)) {
        this.earlyReturnError = 'Actual return time must be earlier than the booked end time.';
        return;
      }
      if (selectedMoment.isBefore(bookingStartMoment)) {
        this.earlyReturnError = 'Actual return time cannot be before the booking start time.';
        return;
      }
      this.earlyReturnError = '';
      this.alterBookingLoading = true;
      let existingMetadata = {};
      try {
        existingMetadata = typeof b.metadata === 'string' ? JSON.parse(b.metadata || '{}') : (b.metadata || {});
      } catch (e) {
        existingMetadata = {};
      }
      const fallbackOriginalStart = (this.isIntimap || this.isWSP)
        ? this.depotLocalToUtc(b.start_datetime, geofenceId)
        : start;
      const fallbackOriginalEnd = (this.isIntimap || this.isWSP)
        ? this.depotLocalToUtc(b.end_datetime, geofenceId)
        : moment(b.end_datetime).format('YYYY-MM-DD HH:mm');
      const earlyReturnData = {
        id: String(bookId).split('-')[0],
        start_datetime: (this.isIntimap || this.isWSP) ? this.depotLocalToUtc(b.start_datetime, geofenceId) : start,
        end_datetime: (this.isIntimap || this.isWSP) ? this.depotLocalToUtc(selectedInput, geofenceId) : newEnd,
        metadata: {
          ...existingMetadata,
          early_return: true,
          original_booking_start: existingMetadata.original_booking_start || fallbackOriginalStart,
          original_booking_end: existingMetadata.original_booking_end || fallbackOriginalEnd,
        },
      };
      this.$store.dispatch('API_CALL', {
        $method: 'update_book',
        $postData: {
          data: earlyReturnData,
        },
      }).then((response) => {
        this.alterBookingLoading = false;
        this.dialogEarlyReturn = false;
        this.alterBookingItem = null;
        if (response && response.data && response.data.code == 200) {
          this.$swal({ icon: 'success', title: 'Booking updated', text: 'End time updated to reflect early return.' });
          this.getData();
        } else {
          this.$swal({ icon: 'error', title: get(response, 'data.data.message', 'Update failed') });
        }
      }).catch(() => {
        this.alterBookingLoading = false;
        this.$swal({ icon: 'error', title: 'Update failed' });
      });
    },
    submitEarlyPickup() {
      if (!this.alterBookingItem || !this.alterBookingItem.book_detail) return;
      if (!this.earlyPickupTime) {
        this.earlyPickupError = 'Please select a time.';
        return;
      }
      const b = this.alterBookingItem.book_detail;
      const bookId = b.original_id || b.id;
      const geofenceId = b.start_geofence_id;
      const selectedInput = this.earlyPickupTime && this.earlyPickupTime.includes(' ')
        ? this.earlyPickupTime
        : `${this.earlyPickupDate} ${this.earlyPickupTime}`;
      const selectedMoment = this.parseDepotTime(selectedInput, geofenceId);
      const bookingStartMoment = this.parseDepotTime(b.start_datetime, geofenceId);
      const bookingEndMoment = this.parseDepotTime(b.end_datetime, geofenceId);
      const allowedValues = this.getEarlyPickupTimeOptions(b).map(t => t.value);
      const newStart = selectedMoment.format('YYYY-MM-DD HH:mm');
      const end = moment(b.end_datetime).format('YYYY-MM-DD HH:mm');
      if (!allowedValues.includes(selectedInput)) {
        this.earlyPickupError = 'Selected time is not allowed for current booking state.';
        return;
      }
      if (selectedMoment.isSameOrAfter(bookingStartMoment)) {
        this.earlyPickupError = 'Actual pickup time must be earlier than the booked start time.';
        return;
      }
      const twoHoursBeforeStart = bookingStartMoment.clone().subtract(2, 'hours');
      if (selectedMoment.isBefore(twoHoursBeforeStart)) {
        this.earlyPickupError = 'Actual pickup time can be at most 2 hours before the booked start time.';
        return;
      }
      if (selectedMoment.isAfter(bookingEndMoment)) {
        this.earlyPickupError = 'Actual pickup time cannot be after the booking end time.';
        return;
      }
      // Moving the start back up to two hours can walk straight into the
      // booking before this one, and nothing here used to look. Best effort
      // only: getBookData holds the page of bookings this view has loaded, and
      // for a non-admin that is just their own, so update_book still has to run
      // the authoritative check. INT-004972.
      const currentAssetId = b.vehicle_id ? b.vehicle_id : b.asset_id;
      const baseBookId = String(bookId).split('-')[0];
      const clashedBooking = (this.getBookData || []).find((row) => {
        const other = row && row.book_detail;
        if (!other || row.readonly == 1) return false;
        const otherAssetId = other.vehicle_id ? other.vehicle_id : other.asset_id;
        if (!currentAssetId || !otherAssetId) return false;
        if (parseInt(otherAssetId) !== parseInt(currentAssetId)) return false;
        // Every row split out of one booking shares its base id, so this keeps
        // the booking being moved from clashing with itself.
        if (String(other.original_id || other.id).split('-')[0] === baseBookId) return false;
        const otherStart = this.parseDepotTime(other.start_datetime, other.start_geofence_id);
        const otherEnd = this.parseDepotTime(other.end_datetime, other.start_geofence_id);
        if (!otherStart.isValid() || !otherEnd.isValid()) return false;
        return selectedMoment.isBefore(otherEnd) && bookingEndMoment.isAfter(otherStart);
      });
      if (clashedBooking) {
        this.earlyPickupError = 'Another booking on this vehicle covers that time. Please choose a later pickup time.';
        return;
      }
      this.earlyPickupError = '';
      this.alterBookingLoading = true;
      let existingMetadata = {};
      try {
        existingMetadata = typeof b.metadata === 'string' ? JSON.parse(b.metadata || '{}') : (b.metadata || {});
      } catch (e) {
        existingMetadata = {};
      }
      const fallbackOriginalStart = (this.isIntimap || this.isWSP)
        ? this.depotLocalToUtc(b.start_datetime, geofenceId)
        : moment(b.start_datetime).format('YYYY-MM-DD HH:mm');
      const earlyPickupData = {
        id: String(bookId).split('-')[0],
        start_datetime: (this.isIntimap || this.isWSP) ? this.depotLocalToUtc(selectedInput, geofenceId) : newStart,
        end_datetime: (this.isIntimap || this.isWSP) ? this.depotLocalToUtc(b.end_datetime, geofenceId) : end,
        metadata: {
          ...existingMetadata,
          early_pickup: true,
          original_booking_start: existingMetadata.original_booking_start || fallbackOriginalStart,
        },
      };
      this.$store.dispatch('API_CALL', {
        $method: 'update_book',
        $postData: {
          data: earlyPickupData,
        },
      }).then((response) => {
        this.alterBookingLoading = false;
        this.dialogEarlyPickup = false;
        this.alterBookingItem = null;
        if (response && response.data && response.data.code == 200) {
          this.$swal({ icon: 'success', title: 'Booking updated', text: 'Start time updated to reflect early pickup.' });
          this.getData();
        } else {
          this.$swal({ icon: 'error', title: get(response, 'data.data.message', 'Update failed') });
        }
      }).catch(() => {
        this.alterBookingLoading = false;
        this.$swal({ icon: 'error', title: 'Update failed' });
      });
    },
    getAssetType() {
      this.$store.dispatch('API_CALL', {
          $method: 'get_asset_types',
          $postData: {
            clientid: this.$store.state.clientid,
          },
        })
        .then((response) => {
          if (response && response.data && response.data.data) {
            this.assetTypes = response.data.data;
          } else {
            this.assetTypes = [];
          }
        })
        .catch(() => {});
    },
    submitDeleteBooking() {
      this.loadingUpdate = true;
      this.loader = this.loadingUpdate;
      this.token = this.$store.state.token;
        this.$store.dispatch('API_CALL', {
            $method: 'delete_book',
            $postData: {
              book_id: this.deleteTarget.book_id,
            },
          })
          .then((response) => {
            if (!response || !response.data) return;
            if(response.data.code == 200) {
              this.deldialog = false
              this.loadingUpdate = false;
              this.loader = this.loadingUpdate;
              this.$swal({
                icon: "success",
                title: (response.data.data && response.data.data.message) || 'Deleted successfully',
              });
              Promise.all([
                this.getBookTotal(),
                this.getData(),
              ]).then(() => {
                if (this.bookTotal > 0 && this.getBookData.length === 0) {
                  this.paginationOptions.page = 1
                  this.getBookTotal();
                  this.getData();
                }
                
                if (this.dialog && this.selectedOrigin && this.selectedOrigin.book_detail) {
                  const updatedBooking = this.getBookData.find(b => b.book_detail.id === this.selectedOrigin.book_detail.id);
                  if (updatedBooking && updatedBooking.book_detail.passenger) {
                    this.selectedOrigin.book_detail.passenger = updatedBooking.book_detail.passenger;
                  }
                }
              })
            } else {
              this.$swal({
                icon: "error",
                title: (response.data.data && response.data.data.message) || 'Delete failed',
              });
            }
          })
          .catch(() => {
            this.loadingUpdate = false;
            this.loader = false;
          });
    },
    getConfirmOriginName(selectedOrigin) {
      if (selectedOrigin == null) return;
      const metadata = this.getPoolData.find(
        (g) => g.Id == selectedOrigin.start_geofence_id
      );
      if (!metadata) return;
      return metadata.name;
    },
    getConfirmVehicleName(selectedOrigin) {
      if (selectedOrigin == null) return;
      let metadata = "";
      let getModel = "";
      if (!isNull(selectedOrigin.vehicle_name)) {
        getModel = this.getVehicles.find(
          (veh) => veh.id == selectedOrigin.vehicle_id
        )
        metadata = `${selectedOrigin.vehicle_name} - ${getModel.device_make} ${getModel.device_model.replace(
          /[^\w\s]/gi,
          ""
        )}`;
      } else if (!isNull(selectedOrigin.asset_id)) {
        const typeName = this.assetTypes.find((d) => d.id == selectedOrigin.asset_type);

        metadata = `${get(typeName, "name", "-")} - ${selectedOrigin.asset_number}`;
      } else {
        metadata = "--";
      }
      if (!metadata) return;
      return metadata;
    },
    getVehicleName(item) {

      if (item == null) return;
      let metadata = "";
      if (!isNull(item.vehicle_name)) {
        metadata = `Vehicle - ${item.vehicle_name}`;
      } else if (!isNull(item.asset_id)) {
        const typeName = this.assetTypes.find((d) => d.id == item.asset_type);

        metadata = `${get(typeName, "name", "-")} - ${item.asset_number}`;
      } else {
        metadata = "--";
      }
      if (!metadata) return;
      if (this.isWollongong || this.isIntimap) {
        const make = this.getVehicleMake(item);
        const model = this.getVehicleModel(item);
        if (make && model) {
          metadata = `${metadata} - ${make} ${model}`;
        } else if (make) {
          metadata = `${metadata} - ${make}`;
        } else if (model) {
          metadata = `${metadata} - ${model}`;
        }
      }
      return metadata;
    },
    getVehicleMake(item) {
      if (item == null) return;
      const vehicle = this.getVehicles.find(
        (veh) => veh.id == item.vehicle_id
      );
      if (vehicle) {
        return vehicle.device_make || "";
      }
      return "";
    },
    getVehicleModel(item) {
      if (item == null) return;
      const vehicle = this.getVehicles.find(
        (veh) => veh.id == item.vehicle_id
      );
      if (vehicle) {
        return vehicle.device_model ? vehicle.device_model.replace(/[^\w\s]/gi, "") : "";
      }
      return "";
    },
    getDates(selectedOrigin) {
      if (selectedOrigin == null) return;
      if (selectedOrigin.hasOwnProperty("start_datetime")) {
        const start = moment(selectedOrigin.start_datetime, "YYYY-MM-DD");
        const end = moment(selectedOrigin.end_datetime, "YYYY-MM-DD");
        const duration = moment.duration(end.diff(start));
        const day = duration.days();
        if (day == 0) {
          if (start == moment().format("YYYY-MM-DD")) {
            return "Today";
          } else {
            return `${start.format("D MMM YYYY")}`;
          }
        } else {
          return `${start.format("D")} \u2014 ${end.format("D")} ${start.format(
            "MMM YYYY"
          )}`;
        }
      }
    },
    getDuration(selectedOrigin) {
      if (selectedOrigin == null) return;
      if (selectedOrigin.hasOwnProperty("start_datetime")) {
        const start = moment(selectedOrigin.start_datetime).format("HH:mm");
        const end = moment(selectedOrigin.end_datetime).format("HH:mm");
        return `${start} \u2014 ${end}`;
      }
    },
    showCostCode(bookDetail) {
      let show = false;
      let metadata = {};
      try {
        metadata = JSON.parse(get(bookDetail, 'metadata', ''));
      } catch(e) {}
      if (metadata.hasOwnProperty('cost_code')) {
        if (metadata.cost_code) {
          show = true;
        }
      }
      return show;
    },
    getCostCode(bookDetail) {
      let costCode = '';
      let metadata = {};
      try {
        metadata = JSON.parse(get(bookDetail, 'metadata', ''));
      } catch(e) {}
      if (metadata.hasOwnProperty('cost_code')) {
        if (metadata.cost_code) {
          costCode = metadata.cost_code;
        }
      }
      return costCode;
    },
    showWorkOrder(bookDetail) {
      let show = false;
      let metadata = {};
      try {
        metadata = JSON.parse(get(bookDetail, 'metadata', ''));
      } catch(e) {}
      if (metadata.hasOwnProperty('work_order')) {
        if (metadata.work_order) {
          show = true;
        }
      }
      return show;
    },
    getWorkOrder(bookDetail) {
      let workOrder = '';
      let metadata = {};
      try {
        metadata = JSON.parse(get(bookDetail, 'metadata', ''));
      } catch(e) {}
      if (metadata.hasOwnProperty('work_order')) {
        if (metadata.work_order) {
          workOrder = metadata.work_order;
        }
      }
      if (workOrder) {
        const workOrderData = this.workOrders.find((wo) => wo.code == workOrder);
        if (workOrderData) {
          workOrder = workOrderData.code;
        }
      }
      return workOrder;
    },
    getWorkOrderText(item) {
      if (!item) return '';
      if (typeof item === 'string') return item;
      return item.code;
    },
    startEditWorkOrder() {
      this.isEditingWorkOrder = true;
      const currentWorkOrder = this.getWorkOrder(this.selectedOrigin.book_detail);
      if (currentWorkOrder) {
        const workOrderData = this.workOrders.find((wo) => wo.code == currentWorkOrder);
        if (workOrderData) {
          this.editingWorkOrder = workOrderData;
        } else {
          const currentWO = { code: currentWorkOrder, description: currentWorkOrder };
          this.workOrders.unshift(currentWO);
          this.editingWorkOrder = currentWO;
        }
      } else {
        this.editingWorkOrder = {};
      }
    },
    cancelEditWorkOrder() {
      this.isEditingWorkOrder = false;
      this.editingWorkOrder = {};
      this.searchWorkOrder = '';
    },
    async saveWorkOrder() {
      if (!this.editingWorkOrder || !this.editingWorkOrder.code) {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Please select a work order'
        });
        return;
      }

      this.loadingUpdate = true;
      try {
        await this.$store.dispatch('API_CALL', {
          $method: 'update_booking_work_order',
          $postData: {
            id: this.selectedOrigin.book_detail.id.split('-')[0],
            work_order: this.editingWorkOrder.code,
            is_second: this.selectedOrigin.is_second_booking ? 1 : 0
          }
        });

        // Update local data
        const metadata = JSON.parse(this.selectedOrigin.book_detail.metadata || '{}');
        metadata.work_order = this.editingWorkOrder.code;
        this.selectedOrigin.book_detail.metadata = JSON.stringify(metadata);
        
        this.$swal({
          icon: 'success',
          title: 'Success',
          text: 'Work order updated successfully'
        });
        this.isEditingWorkOrder = false;
        this.editingWorkOrder = {};
        this.searchWorkOrder = '';
        
        const currentBookData = this.getBookData.find(item => item.id == this.selectedOrigin.book_detail.id);
        if (currentBookData) {
          currentBookData.book_detail.metadata = JSON.stringify(metadata);
        }
        this.getData();
      } catch (error) {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Failed to update work order'
        });
        console.error('Error updating work order:', error);
      } finally {
        this.loadingUpdate = false;
      }
    },
    isEmpty(value) {
      return !value || (typeof value === 'object' && Object.keys(value).length === 0);
    },
    canEditBooking(item) {
      // Booking bisa diedit jika memenuhi kondisi pastCondition dan bukan second booking
      return this.pastCondition(item.book_detail) && !item.is_second_booking;
    },
    showPurposeOfTrip(bookDetail) {
      let show = false;
      let metadata = {};
      try {
        metadata = JSON.parse(get(bookDetail, 'metadata', ''));
      } catch(e) {}
      if (metadata.hasOwnProperty('purpose_of_trip')) {
        if (metadata.purpose_of_trip) {
          show = true;
        }
      }
      return show;
    },
    getPurposeOfTrip(bookDetail) {
      let purposeOfTrip = '';
      let metadata = {};
      try {
        metadata = JSON.parse(get(bookDetail, 'metadata', ''));
      } catch(e) {}
      if (metadata.hasOwnProperty('purpose_of_trip')) {
        if (metadata.purpose_of_trip) {
          purposeOfTrip = metadata.purpose_of_trip;
        }
      }
      return purposeOfTrip;
    },
    showClientName(bookDetail) {
      let show = false;
      let metadata = {};
      try {
        metadata = JSON.parse(get(bookDetail, 'metadata', ''));
      } catch(e) {}
      if (metadata.hasOwnProperty('client_name')) {
        if (metadata.client_name) {
          show = true;
        }
      }
      return show;
    },
    getClientName(bookDetail) {
      let clientName = '';
      let metadata = {};
      try {
        metadata = JSON.parse(get(bookDetail, 'metadata', ''));
      } catch(e) {}
      if (metadata.hasOwnProperty('client_name')) {
        if (metadata.client_name) {
          clientName = metadata.client_name;
        }
      }
      return clientName;
    },
    getCarParkLocation(bookDetail) {
      if (bookDetail && bookDetail.vehicle_id) {
        const vehicle = this.getVehicles.find((v) => v.id == bookDetail.vehicle_id);
        if (vehicle) {
          return get(vehicle, 'metadata.parking_location', '');
        }
      }
      return '';
    },
    getKeCabinetLocation(bookDetail) {
      if (bookDetail && bookDetail.vehicle_id) {
        const vehicle = this.getVehicles.find((v) => v.id == bookDetail.vehicle_id);
        if (vehicle) {
          return get(vehicle, 'cabinet_name', '');
        }
      }
      return '';
    },
    getDestinationAddrs(selectedOrigin) {
      if (selectedOrigin == null) return;
      let metadata = "";
      if (selectedOrigin.hasOwnProperty("metadata")) {
        metadata = selectedOrigin.metadata;
        if (metadata == "[]") {
          const metadata = this.getDestinationData.find(
            (g) => g.Id == selectedOrigin.end_geofence_id
          );
          if (!metadata) return;
          return metadata.name;
        } else {
          return getBookingDestinationText(selectedOrigin.metadata);
        }
      }
    },
    startDateFormat(item) {
      if (item == null) return;
      let date = null;
      if (item.hasOwnProperty("start_datetime")) {
        date = moment(item.start_datetime).format('ddd, D MMM YYYY HH:mm')
      }
      return date;
    },
    endDateFormat(item) {
      if (item == null) return;
      let date = null;
      if (item.hasOwnProperty("end_datetime")) {
        date = moment(item.end_datetime).format('ddd, D MMM YYYY HH:mm')
      }
      return date;
    },
    formatDate(date, format = 'D MMM YYYY HH:mm') {
      if (date == null) return;
      const dateFormatted = moment(date).format(format)
      return dateFormatted;
    },
    getBookTotal() {
      this.token = this.$store.state.token;
      this.clientid = this.$store.state.clientid;
      const origins = this.isWSP || this.isIntimap ? this.filterredOrigins : [];
      const skip_past_date = this.showHistory ? 0 : 1;
      if (this.$store.state.type == 3) {
        return this.$store.dispatch('API_CALL', {
            $method: 'get_book_total',
            $postData: {
              status: 2,
              query: this.searchData,
              get_schedules: 0,
              skip_past_date,
              origins,
            },
          })
          .then((response) => {
            if (response && response.data && response.data.data) {
              this.bookTotal = parseInt(response.data.data.total);
            } else {
              this.bookTotal = 0;
            }
          })
          .catch(() => {});
      } else if (this.$store.state.type == 2 || this.$store.state.type == 4) {
        return this.$store.dispatch('API_CALL', {
            $method: 'get_book_total',
            $postData: {
              user_id: this.$store.state.user.user.id,
              clientid: this.$store.state.clientid,
              status: 2,
              query: this.searchData,
              get_schedules: 0,
              skip_past_date,
              origins,
            },
          })
          .then((response) => {
            if (response && response.data && response.data.data) {
              this.bookTotal = parseInt(response.data.data.total);
            } else {
              this.bookTotal = 0;
            }
          })
          .catch(() => {});
      } else if (this.$store.state.type == 1 || this.$store.state.type == 5) {
        return this.$store.dispatch('API_CALL', {
            $method: 'get_book_total',
            $postData: {
              clientid: this.$store.state.clientid,
              status: 2,
              query: this.searchData,
              get_schedules: 0,
              skip_past_date,
              origins,
            },
          })
          .then((response) => {
            if (response && response.data && response.data.data) {
              this.bookTotal = parseInt(response.data.data.total);
            } else {
              this.bookTotal = 0;
            }
          })
          .catch(() => {});
      }
    },
    getData() {
      if (this.loadingBook) return;
      this.token = this.$store.state.token;
      this.clientid = this.$store.state.clientid;
      this.loadingBook = true;

      const { page, itemsPerPage, sortBy, sortDesc } = this.paginationOptions;
      const sort_by  = sortBy.length ? sortBy[0] : 'book_detail.created_at';
      const sort_dir = sortDesc.length ? (sortDesc[0] ? 'desc' : 'asc') : 'desc';
      const offset   = (page - 1) * itemsPerPage;

      let by = 'book_id';

      switch(sort_by) {
        case 'book_detail.id':
            by = 'book_id';
            break;
        case 'first_name':
            by = 'first_name';
            break;
        case 'last_name':
            by = 'last_name';
            break;
        case 'book_detail.start_geofence_id':
            by = 'origin';
            break;
        case 'book_detail.vehicle_name':
            by = 'asset';
            break;
        case 'book_detail.start_datetime':
            by = 'start_date';
            break;
        case 'book_detail.end_datetime':
            by = 'end_date';
            break;
        case 'book_detail.created_at':
            by = 'created_at';
            break;
        default:
          break;
      }

      const skip_past_date = this.showHistory ? 0 : 1;

      if (this.$store.state.type == 3) {
        const payloadData = {
          clientid: this.$store.state.clientid,
          limit: itemsPerPage,
          offset,
          sort_by: by,
          sort_dir,
          query: this.searchData,
          status: 2,
          get_schedules: 0,
          get_recurring: 1,
          skip_past_date
        };
        if (this.isIntimap || this.isWSP) {
          payloadData.use_timezone_depot = 1;
          payloadData.origins = this.filterredOrigins;
        }
        return this.$store.dispatch('API_CALL', {
            $method: 'get_all_book',
            $postData: payloadData,
          })
          .then((response) => {
            this.loadingBook = false;
            const bookings = response && response.data && response.data.data;
            if (Array.isArray(bookings)) {
              const filteredBookings = bookings.filter(
                (booking) => booking.book_detail.status == 2
              );
              this.getBookData = this.processBookingData(filteredBookings);
            } else {
              this.getBookData = [];
            }
          })
          .catch(() => {
            this.loadingBook = false;
          });
      } else if (this.$store.state.type == 2 || this.$store.state.type == 4) {
        const payloadData = {
          user_id: this.$store.state.user.user.id,
          clientid: this.$store.state.clientid,
          limit: itemsPerPage,
          offset,
          sort_by: by,
          sort_dir,
          query: this.searchData,
          status: 2,
          get_schedules: 0,
          get_recurring: 1,
          skip_past_date
        };
        if (this.isIntimap || this.isWSP) {
          payloadData.use_timezone_depot = 1;
          payloadData.origins = this.filterredOrigins;
        }
        return this.$store.dispatch('API_CALL', {
            $method: 'get_all_book',
            $postData: payloadData,
          })
          .then((response) => {
            this.loadingBook = false;
            const bookings = response && response.data && response.data.data;
            if (Array.isArray(bookings)) {
              const filteredBookings = bookings.filter(
                (booking) => booking.book_detail.status == 2
              );
              this.getBookData = this.processBookingData(filteredBookings);
            } else {
              this.getBookData = [];
            }
          })
          .catch(() => {
            this.loadingBook = false;
          });
      } else if (this.$store.state.type == 1 || this.$store.state.type == 5) {
        const payloadData = {
          clientid: this.$store.state.clientid,
          limit: itemsPerPage,
          offset,
          sort_by: by,
          sort_dir,
          query: this.searchData,
          status: 2,
          get_schedules: 0,
          get_recurring: 1,
          skip_past_date
        };
        if (this.isIntimap || this.isWSP) {
          payloadData.use_timezone_depot = 1;
          payloadData.origins = this.filterredOrigins;
        }
        return this.$store.dispatch('API_CALL', {
            $method: 'get_all_book',
            $postData: payloadData,
          })
          .then((response) => {
            this.loadingBook = false;
            const bookings = response && response.data && response.data.data;
            if (Array.isArray(bookings)) {
              const filteredBookings = bookings.filter(
                (booking) => booking.book_detail.status == 2
              );
              this.getBookData = this.processBookingData(filteredBookings);
            } else {
              this.getBookData = [];
            }
          })
          .catch(() => {
            this.loadingBook = false;
          });
      }
    },
    getDataVehicles() {
      this.token = this.$store.state.token;
      this.clientid = this.$store.state.clientid;
      this.$store.dispatch('API_CALL', {
          $method: 'get_vehicles',
          $postData: {
            clientid: this.clientid,
          },
        })
        .then((response) => {
          if (response && response.data && response.data.data) {
            this.getVehicles = response.data.data;
            this.getDevice = response.data.data.length;
          } else {
            this.getVehicles = [];
            this.getDevice = 0;
          }
          this.deviceLoaded = true;
        })
        .catch(() => {
          this.deviceLoaded = true;
          this.getVehicles = [];
          this.getDevice = 0;
        })
    },
    pastCondition(item, isDelete = false) {
      if (!item) return false;
      const isRecurring = item.hasOwnProperty('booking_recurring');
      const now = moment().unix();
      let end = this.parseDepotTime(item.end_datetime, item.start_geofence_id).unix();
      if (isRecurring) {
        if (item.booking_recurring.length > 0) {
          const recurring = item.booking_recurring;
          const lastRecurring = recurring[recurring.length - 1];
          end = this.parseDepotTime(lastRecurring.end_datetime, item.start_geofence_id).unix();
        }
      }
      if (end > now) return true;
      return false;
    },
    /** Ambil IANA timezone depot (misal "Asia/Bangkok") dari geofence origin. */
    getDepotIanaTimezone(geofenceId) {
      if (!geofenceId) return null;
      const origin = this.getPoolData.find(o => o.Id && o.Id.toString() === geofenceId.toString());
      if (!origin) return null;
      const tz = get(origin, 'metadata.timezone.timeZoneId');
      if (!tz) return null;
      const matched = this.timezones.find(t => {
        if (typeof t.type === 'string') return t.type === tz;
        if (Array.isArray(t.type)) return t.type.includes(tz);
        return false;
      });
      return matched ? (typeof matched.type === 'string' ? matched.type : matched.type[0]) : null;
    },
    /** Parse datetime string sesuai timezone depot (agar perbandingan dgn moment() benar). */
    parseDepotTime(datetimeStr, geofenceId) {
      if ((this.isIntimap || this.isWSP) && geofenceId) {
        const ianaTz = this.getDepotIanaTimezone(geofenceId);
        if (ianaTz) {
          return momentTz.tz(moment(datetimeStr).format('YYYY-MM-DD HH:mm'), 'YYYY-MM-DD HH:mm', ianaTz);
        }
      }
      return moment(datetimeStr);
    },
    /** Konversi datetime lokal depot ke UTC string (YYYY-MM-DD HH:mm). */
    depotLocalToUtc(localDatetime, geofenceId) {
      const ianaTz = this.getDepotIanaTimezone(geofenceId);
      if (ianaTz) {
        return momentTz.tz(moment(localDatetime).format('YYYY-MM-DD HH:mm'), 'YYYY-MM-DD HH:mm', ianaTz).utc().format('YYYY-MM-DD HH:mm');
      }
      return moment(localDatetime).format('YYYY-MM-DD HH:mm');
    },
    bookingHasStarted(bookDetail) {
      if (!bookDetail || !bookDetail.start_datetime) return false;
      const start = this.parseDepotTime(bookDetail.start_datetime, bookDetail.start_geofence_id);
      return moment().isSameOrAfter(start);
    },
    getEarlyReturnMinMoment(bookDetail) {
      if (!bookDetail || !bookDetail.start_datetime) return null;
      const start = this.parseDepotTime(bookDetail.start_datetime, bookDetail.start_geofence_id);
      const minFromStart = start.clone().add(30, 'minutes');
      return moment.max(moment(), minFromStart);
    },
    floorToHalfHour(datetimeMoment) {
      const m = datetimeMoment.clone().seconds(0).milliseconds(0);
      m.minutes(m.minutes() >= 30 ? 30 : 0);
      return m;
    },
    ceilToHalfHour(datetimeMoment) {
      const m = datetimeMoment.clone().seconds(0).milliseconds(0);
      const minute = m.minutes();
      if (minute === 0 || minute === 30) return m;
      if (minute < 30) {
        m.minutes(30);
        return m;
      }
      return m.add(1, 'hour').minutes(0);
    },
    getEarlyReturnTimeOptions(bookDetail) {
      if (!bookDetail || !bookDetail.start_datetime || !bookDetail.end_datetime) return [];
      const start = this.parseDepotTime(bookDetail.start_datetime, bookDetail.start_geofence_id);
      const end = this.parseDepotTime(bookDetail.end_datetime, bookDetail.start_geofence_id);
      const now = moment();

      const isMultiDay = !start.isSame(end, 'day');

      if (now.isAfter(end)) {
        const first = this.ceilToHalfHour(start);
        const last = this.floorToHalfHour(end);
        const options = [];
        const cursor = first.clone();
        while (cursor.isSameOrBefore(last)) {
          options.push({
            label: isMultiDay ? cursor.format('D MMM HH:mm') : cursor.format('HH:mm'),
            value: cursor.format('YYYY-MM-DD HH:mm'),
          });
          cursor.add(30, 'minutes');
        }
        return options;
      }

      const minFromStart = start.clone().add(30, 'minutes');
      const nowSlot = this.floorToHalfHour(now);
      if (nowSlot.isBefore(minFromStart) || nowSlot.isSameOrAfter(end)) {
        return [];
      }

      const first = this.ceilToHalfHour(minFromStart);
      const options = [];
      const cursor = first.clone();
      while (cursor.isSameOrBefore(nowSlot)) {
        options.push({
          label: isMultiDay ? cursor.format('D MMM HH:mm') : cursor.format('HH:mm'),
          value: cursor.format('YYYY-MM-DD HH:mm'),
        });
        cursor.add(30, 'minutes');
      }
      return options;
    },
    getEarlyPickupTimeOptions(bookDetail) {
      if (!bookDetail || !bookDetail.start_datetime) return [];
      const start = this.parseDepotTime(bookDetail.start_datetime, bookDetail.start_geofence_id);
      const now = moment();
      if (now.isSameOrAfter(start)) {
        return [];
      }

      const twoHoursBefore = start.clone().subtract(2, 'hours');
      const first = this.ceilToHalfHour(twoHoursBefore);
      const upper = this.floorToHalfHour(now);
      if (upper.isBefore(first)) {
        return [];
      }

      const options = [];
      const cursor = first.clone();
      while (cursor.isSameOrBefore(upper) && cursor.isBefore(start)) {
        options.push({
          label: cursor.format('HH:mm'),
          value: cursor.format('YYYY-MM-DD HH:mm'),
        });
        cursor.add(30, 'minutes');
      }
      return options;
    },
    withinEarlyReturnWindow(bookDetail) {
      return this.getEarlyReturnTimeOptions(bookDetail).length > 0;
    },
    withinEarlyPickupWindow(bookDetail) {
      return this.getEarlyPickupTimeOptions(bookDetail).length > 0;
    },
    /** True jika booking sudah punya tag early return (cuma boleh sekali). */
    hasEarlyReturnTag(bookDetail) {
      if (!bookDetail || !bookDetail.metadata) return false;
      try {
        const meta = typeof bookDetail.metadata === 'string' ? JSON.parse(bookDetail.metadata) : bookDetail.metadata;
        return meta && (meta.early_return === true || meta.early_return === 'true');
      } catch (e) {
        return false;
      }
    },
    /** True jika booking sudah punya tag early pickup (cuma boleh sekali). */
    hasEarlyPickupTag(bookDetail) {
      if (!bookDetail || !bookDetail.metadata) return false;
      try {
        const meta = typeof bookDetail.metadata === 'string' ? JSON.parse(bookDetail.metadata) : bookDetail.metadata;
        return meta && (meta.early_pickup === true || meta.early_pickup === 'true');
      } catch (e) {
        return false;
      }
    },
    sameUser(item) {
      if(item.created_by === this.$store.state.user.user.id) {
        return true
      } else {
        return false
      }
    },
    cancelBooking(item) {
      this.deldialog = true;
      this.deleteTarget = item;
    },
    isCanCancelJoin(item) {
      const bookingItem = this.getBookData.find(b => b.book_detail.id == item.book_id);
      if (!bookingItem) return false;
      if (!this.pastCondition(bookingItem.book_detail)) return false;
      const bookingOrigin = this.selectedOrigin.book_detail.passenger.find((p) => {
        return p.is_owner == true;
      });
      if (bookingOrigin && this.selectedOrigin.book_detail.id == bookingOrigin.book_id) {
        return item.user_id != this.$store.state.user.user.id;
      } else {
        return item.user_id == this.$store.state.user.user.id;
      }
    },
    cancelJoin(item) {
      this.deldialog = true;
      this.deleteTarget = this.getBookData.find(b => b.book_id === item.book_id);
    },
    onDelete(book_id) {
      this.clientid = this.$store.state.clientid;
      this.token = this.$store.state.token;
    },
    getVehicleId(vehicles) {
      if (!vehicles) return;
      this.vehicleId = vehicles.id;
      if (vehicles.hasOwnProperty("vehicle_name")) {
        this.setVehicleName = vehicles.vehicle_name;
      } else if (vehicles.hasOwnProperty("name")) {
        this.setVehicleName = vehicles.name;
      }
      this.e1 = 3;
    },
    getPassengerList(data) {
      if (data.book_metadata && data.book_metadata.hasOwnProperty("passenger_list")) {
        let passengerList = data.book_metadata.passenger_list;
        if (typeof passengerList === "string") {
          try {
            passengerList = JSON.parse(passengerList);
          } catch (e) {
            passengerList = [];
          }
        }
        return passengerList;
      } else {
        return [];
      }
    },
    editItem(item) {
      this.editedItem.passenger_count = item.passenger_count;
      this.selectedId = item.book_id;
      this.dialog = true;
      this.selectedOrigin = { ...item };
      
      this.isEditingWorkOrder = false;
      this.editingWorkOrder = {};
      this.searchWorkOrder = '';
      
      this.ensureAllCurrentWorkOrdersInList();
      let metadata = [];
      try {
        metadata = JSON.parse(item.book_detail.metadata);
      } catch (e) {}

      if (metadata.hasOwnProperty("address")) {
        this.selectedAddr = getBookingDestinationText(metadata) || metadata.address;
        this.setDestination = {
          type: "address",
          latitude: item.book_detail.end_latitude,
          longitude: item.book_detail.end_longitude,
        };
        const lat = parseFloat(this.setDestination.latitude);
        const lat2 = parseFloat(item.book_detail.start_latitude);
        const lng = parseFloat(this.setDestination.longitude);
        this.destPosition = { lat, lng };
        this.center = { lat2, lng };
      } else {
        this.setDestination = {
          type: "geofence",
          geofence_id: item.book_detail.end_geofence_id,
        };
        const geo = this.getDestinationData.find(
          (g) => g.Id == item.book_detail.end_geofence_id
        );
        if (!geo) return;
        this.selectedAddr = geo.name;
        const lat = (parseFloat(geo.top) + parseFloat(geo.bottom)) / 2;
        const lng = (parseFloat(geo.left) + parseFloat(geo.right)) / 2;

        const geo2 = this.getPoolData.find(
          (g) => g.Id == item.book_detail.start_geofence_id
        );
        if (!geo2) return;
        const lat2 = (parseFloat(geo2.top) + parseFloat(geo2.bottom)) / 2;
        this.destPosition = { lat, lng };
        this.center = { lat2, lng };
      }
      this.editedItem = this.selectedOrigin;
      this.startDateTime = moment(
        this.editedItem.book_detail.start_datetime
      )._d;
      this.endDateTime = moment(this.editedItem.book_detail.end_datetime)._d;
      this.selectedVehicle = this.getVehicles.find(
        (g) => g.id == this.editedItem.book_detail.vehicle_id
      );
      this.selectedStartDate = moment(
        this.editedItem.book_detail.start_datetime
      ).format("YYYY-MM-DD");
      this.selectedStartTime = moment(
        this.editedItem.book_detail.start_datetime
      ).format("HH:mm");
    },
    getOriginName(item) {
      if (item == null) return;
      let destination = "";
      if (item.start_geofence_id != 0) {
        if (this.$store.state.type == 3) {
          for (var k in this.all_geofences) {
            this.all_geofences[k].forEach((group) => {
              const geofenceDestination = group.geofences.find(
                (geofence) =>
                  parseInt(geofence.Id) === parseInt(item.start_geofence_id)
              );
              if (!isUndefined(geofenceDestination)) {
                destination = geofenceDestination.name;
              }
            });
          }
        } else {
          this.geofences[this.$store.state.clientid].forEach((group) => {
            const geofenceDestination = group.geofences.find(
              (geofence) =>
                parseInt(geofence.Id) === parseInt(item.start_geofence_id)
            );
            if (!isUndefined(geofenceDestination)) {
              destination = geofenceDestination.name;
            }
          });
        }
      }
      return destination;
    },
    getTypeName(vehicles) {
      if (vehicles == null) return;
      const metadata = this.getVehicles.find(
        (g) => g.id == vehicles.id
      );
      if (!metadata) return;
      return metadata.type_name;
    },
    getDestinationAddr(item) {
      if (item == null) return;
      let destination = "";
      let stopFind = false;
      if (item.end_geofence_id != 0 && !isEmpty(item.end_geofence_id)) {
        if (this.$store.state.type == 3) {
          for (var k in this.all_geofences) {
            this.all_geofences[k].forEach((group) => {
              if (stopFind === false) {
                const geofenceDestination = group.geofences.find(
                  (geofence) =>
                    parseInt(geofence.Id) === parseInt(item.end_geofence_id)
                );
                if (!isUndefined(geofenceDestination)) {
                  destination = geofenceDestination.name;
                  stopFind = true;
                }
              }
            });
          }
        } else {
          this.geofences[this.$store.state.clientid].forEach((group) => {
            if (stopFind === false) {
              const geofenceDestination = group.geofences.find(
                (geofence) =>
                  parseInt(geofence.Id) === parseInt(item.end_geofence_id)
              );
              if (!isUndefined(geofenceDestination)) {
                destination = geofenceDestination.name;
                stopFind = true;
              }
            }
          });
        }
      }
      else if (isNull(item.end_geofence_id)) {
        return getBookingDestinationText(item.metadata, 2);
      }
      else if (item.metadata && item.metadata.hasOwnProperty("address")) {
        destination = getBookingDestinationText(item.metadata, 2) ||
          `${item.start_longitude},${item.end_longitude}`;
      }
      else {
        return getBookingDestinationText(item.metadata, 2);
      }
      return destination;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 1024) {
        this.responsive = false;
      } else {
        this.responsive = true;
      }
    },
    getAllDevice() {},
    getAddress(item) {
      const data = JSON.parse(item.metadata);
      return data.created_date;
    },
    updatePaging(options) {
      this.getBookTotal();
      this.paginationOptions = options;
      this.getData();
    },
    doSearch() {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.paginationOptions.page     = 1;
        this.paginationOptions.sortBy   = [];
        this.paginationOptions.sortDesc = [];
        this.getBookTotal();
        this.getData();
      }, 1e3)
    },
    loadRecurringData(bookId) {
      this.selectedBookId = bookId;
      this.$store.commit('CLEAR_SCHEDULES');
      this.$store.dispatch('LOAD_SCHEDULES', {
        token: this.$store.state.token,
        book_id: bookId
      })
    },
    clearSchedules() {
      this.selectedBookId = null;
      this.$store.commit('CLEAR_SCHEDULES');
    },
    // getOriginName(item) {
    //   if (item == null) return
    //   const metadata = this.getPoolData.find(g => g.Id == 'Depot 1')
    //   if (!metadata) return
    //   return metadata.name
    // },
    getCarpoolURL() {
      return process.env.VUE_APP_CARPOOLING_URL;
    },
    handleShowHistory() {
      this.getBookTotal();
      this.getData();
    },
    toTimezoneUser(item, key) {
      try {
        const metadata = JSON.parse(item.metadata);
        if (metadata.hasOwnProperty(key)) {
          const date = metadata[key].adatetime;
          const userTimezone = this.timezones.find(
            (tz) => tz.name === item.book_user.timezone
          );
          if (userTimezone) {
            return moment.utc(date)
              .tz(userTimezone.type)
              .format('ddd, D MMM YYYY HH:mm');  
          }
        }
      } catch (e) {}

      return '';
    }
  }
};
</script>
<style lang="css" scoped>
  .v-sheet--offset {
    top: -24px;
    position: relative;
    border-radius: 14px;
  }
  .text-class{
    top: -10px;
  }
  .text-offset{
    bottom: -24px;
  }
  .icon-clas{
    top: -15px;
  }
  .custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.vs__search {
  height: 45px;
}
.vs {
  color: #ff5252 !important;
  border: 2px solid #ff5252 !important;
  border-radius: 5px;
  font-size: 400 15.3333px Arial;
}
.noerror {
  border-radius: 5px;
  font-size: 400 15.3333px Arial;
}
</style>
<style>
.my-data-table table {
  table-layout: fixed;
}
.my-data-table table th {
  text-align: left;
}
.my-data-table table th.cabinet-item-no-col span {
  white-space: break-spaces;
}
.swal2-title {
  padding: 17px;
  display: block;
  margin: 22px;
  text-align: center;
  color: #61534e;
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-text {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-content {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
  text-align: center;
  color: #61534e;
}
.swal2-html {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-input {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-cancel {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-confirm {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.v-chip.v-size--default {
  height: 20px;
}
</style>
<style>
.my-booking-dialog {
  overflow: visible !important;
}
</style>
